import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.neonPurple,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.neonPurple,
  iconBorderColor: colors.neonPurple,
  iconBorderHoverColor: colors.neonPurple
};
export default socialIcon;